import { ReactComponent as JiraIcon } from '@elementary/common-ui/assets/16x16/jira.svg';
import { ReactComponent as LinearIcon } from '@elementary/common-ui/assets/16x16/linear.svg';
import { ReactComponent as ServiceNowIcon } from '@elementary/common-ui/assets/16x16/servicenow.svg';

export const ticketingIconMap: Record<string, JSX.Element> = {
  jira: <JiraIcon />,
  linear: <LinearIcon />,
  servicenow: <ServiceNowIcon />,
};

export const extractTicketIdFromUrl = (
  url: string,
  service: string,
  ticketId?: string,
): string => {
  try {
    const urlObj = new URL(url);

    switch (service) {
      case 'jira': {
        const match = urlObj.pathname.match(/\/browse\/([A-Z]+-\d+)/i);
        return match?.[1] || url;
      }
      case 'linear': {
        const match = urlObj.pathname.match(/\/([A-Z]+-\d+)/i);
        return match?.[1] || url;
      }
      case 'servicenow': {
        const params = new URLSearchParams(urlObj.search);
        const number = params.get('number');
        if (number) return number;

        const sysparmQuery = params.get('sysparm_query');
        if (sysparmQuery) {
          const numberMatch = sysparmQuery.match(/number=([A-Z0-9]+)/i);
          if (numberMatch?.[1]) return numberMatch[1];
        }

        const uri = params.get('uri');
        if (uri) {
          const uriParams = new URLSearchParams(uri.split('?')[1]);
          const uriNumber = uriParams.get('number');
          if (uriNumber) return uriNumber;

          const uriSysparmQuery = uriParams.get('sysparm_query');
          if (uriSysparmQuery) {
            const numberMatch = uriSysparmQuery.match(/number=([A-Z0-9]+)/i);
            if (numberMatch?.[1]) return numberMatch[1];
          }
        }

        if (ticketId) {
          return ticketId;
        }

        return url;
      }
      default:
        return url;
    }
  } catch {
    return url;
  }
};
